<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sUCWM5/tc-custom/9780062932099.jpg?1726617300341" alt="This image is the cover for the book Stepping Off Place"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stepping Off Place
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From debut author Cameron Kelly Rosenblum comes a stunning teen novel that tackles love, grief, and mental health as one girl must process her friend’s death and ultimately learn how to stand in her own light. Perfect for fans of <i>All the Bright Places</i> and <i>We Were Liars</i>.</b></p><p>It’s the summer before senior year. Reid is in the thick of Scofield High’s in-crowd thanks to her best friend, Hattie, who has been her social oxygen since middle school.</p><p>But summer is when Hattie goes to her family’s Maine island home. Instead of sitting inside for eight weeks, waiting for her to return, Reid and their friend, Sam, enter into a pact—to live it up, one party at a time. </p><p>But days before Hattie is due home, Reid finds out the shocking news that Hattie has died by suicide. Driven by a desperate need to understand what went wrong, Reid searches for answers.</p><p>In doing so, she uncovers painful secrets about the person she thought she knew better than herself. And the truth will force Reid to reexamine everything.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cameron Kelly Rosenblum
      </h2>
      
      <p class="authorDescription body article"><P><B>Cameron Kelly Rosenblum</B> grew up in Connecticut. She studied English literature at Kenyon College and earned a master&#8217;s in education at Lesley University. Her time as a teacher and children&#8217;s librarian inspired her to write for young people. <I>The Stepping Off Place </I>is her debut novel. <I>The Sharp Edge of Silence </I>is her second. Cameron lives near Portland, Maine, with her husband, son, daughter, two dogs, and a cat. Visit her online at www.cameronrosenblum.com or on Twitter @ckellyrose.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d6635b1